/**
 * timeFormat — the ONE humanized-duration formatter for Mission Control +
 * PipelineBoard + the agent drawer.
 *
 * Fix for "ages show days only": item/stage ages arrive as seconds (age_seconds
 * / age_in_stage_secs / oldest_age_secs) and are humanized here instead of the
 * old `${age_days}d` which rendered "0d" for anything under a day.
 *
 * Tiers (single source of truth so a duration reads identically everywhere):
 *   < 60s  → "Xs"   (sub-minute precision for fresh relative times)
 *   < 60m  → "Xm"
 *   < 48h  → "Xh"
 *   else   → "Xd"
 */

/** Humanize an age given in seconds. Returns "—" for invalid/negative input. */
export function fmtAgeSecs(secs: number): string {
  if (!isFinite(secs) || secs < 0) return '—'
  if (secs < 60) return `${Math.floor(secs)}s`
  const min = Math.floor(secs / 60)
  if (min < 60) return `${min}m`
  const hr = Math.floor(min / 60)
  if (hr < 48) return `${hr}h`
  const day = Math.floor(hr / 24)
  return `${day}d`
}

/** Relative "time ago" from an ISO timestamp, using the same tiers as fmtAgeSecs. */
export function relTime(iso: string): string {
  const ms = Date.now() - new Date(iso).getTime()
  if (ms < 0 || !isFinite(ms)) return '—'
  return fmtAgeSecs(ms / 1000)
}
